import { SvgIcon } from '@mui/material';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';

import { Icon } from 'src/components/icon/Icon';
import { CameraIconWhite } from 'src/components/menu-wrapper/components/iot-menu/icons';

export const IotNotificationsActionButton = ({ showCamera, moveToDoor }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (selectedOption?: string) => {
    setAnchorEl(null);
    if (selectedOption === 'showCamera') {
      showCamera();
    }
    if (selectedOption === 'moveToDoor') {
      moveToDoor();
    }
  };

  return (
    <>
      <IconButton onClick={handleClick}>
        <Icon icon="fa-solid fa-ellipsis-vertical" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        MenuListProps={{
          'aria-labelledby': 'menu-button'
        }}
        PaperProps={{
          style: {
            color: 'white',
            background: 'rgba(0, 0, 0, 0.40)',
            backdropFilter: 'blur(40px)',
            borderRadius: '6px',
            pointerEvents: 'all'
          }
        }}
      >
        <MenuItem
          sx={{ gap: 1 }}
          onClick={() => {
            handleClose('showCamera');
          }}
        >
          <SvgIcon>{CameraIconWhite}</SvgIcon>
          Show Camera
        </MenuItem>
        <MenuItem
          sx={{ gap: 1 }}
          onClick={() => {
            handleClose('moveToDoor');
          }}
        >
          <Icon icon="fa-regular fa-door-open" />
          Move to Door
        </MenuItem>
      </Menu>
    </>
  );
};
